import { render, staticRenderFns } from "./MainNotificationComponent.vue?vue&type=template&id=1d63c114&scoped=true"
import script from "./MainNotificationComponent.vue?vue&type=script&lang=js"
export * from "./MainNotificationComponent.vue?vue&type=script&lang=js"
import style0 from "./MainNotificationComponent.vue?vue&type=style&index=0&id=1d63c114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d63c114",
  null
  
)

export default component.exports